import { useLocation, Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useEffect, useRef, useState } from 'react'
import './Sidebar.css'
import { FiAlignJustify } from 'react-icons/fi'
import { FaTable, FaBullhorn, FaUniversity, FaUsers, FaCertificate, FaQuestion, FaList, FaPlus } from 'react-icons/fa';
import { IoHomeOutline } from "react-icons/io5";
import { TbReportAnalytics } from 'react-icons/tb'
import { Ticket } from 'react-bootstrap-icons'
import { PiCertificate } from 'react-icons/pi'
import { BsTicketFill } from 'react-icons/bs'


type LanguageType = 'en' | 'ar';

interface SidebarProps {
  isOpen: boolean
  onToggle: () => void
  language: LanguageType
}

const links = [
  { labelKey: 'Sidebar.Dashboard', href: '/', icon: <IoHomeOutline /> },
  { labelKey: 'Sidebar.Report', href: '/reports', icon: <TbReportAnalytics /> },
  { labelKey: 'Sidebar.Standards', href: '/standards', icon: <FaTable /> },
  { labelKey: 'Sidebar.Tickets', href: '/ticket', icon: <BsTicketFill/> },
  { labelKey: 'Sidebar.Certifications', href: '/certifications', icon: <PiCertificate /> },
  { labelKey: 'Announcement', href: '/announcement', icon: <FaBullhorn /> },
  { labelKey: 'Sidebar.Institutions', href: '/institutions', icon: <FaUniversity /> },
  { labelKey: 'Survey', href: '/surveys', icon: <FaList /> },
  { labelKey: 'Create Survey', href: '/create-survey', icon: <FaPlus /> },
  { labelKey: 'Bank Questions', href: '/bankQuestions', icon: <FaQuestion /> },
 

  { labelKey: 'Sidebar.UserManagement', href: '/user', icon: <FaUsers /> },

]

const Sidebar: React.FC<SidebarProps> = ({ isOpen, onToggle, language }) => {
  const [isMobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const { t } = useTranslation();
  const sidebarRef = useRef<HTMLDivElement>(null);
  const isRTL = language === 'ar';

  useEffect(() => {
    if (isOpen && sidebarRef.current) {
      const activeItem = sidebarRef.current.querySelector('[data-active="true"]');
      activeItem?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [location.pathname, isOpen]);

  const handleMobileToggle = () => {
    setMobileOpen(!isMobileOpen);
    if (!isMobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  };

  return (
    <>

      {/* Desktop Sidebar */}
      <div
        ref={sidebarRef}
        className={`d-none d-md-flex flex-column vh-100 position-relative bg-white ${
          isOpen ? 'sidebar-expanded' : 'sidebar-collapsed'
        } ${isRTL ? 'rtl' : 'ltr'}`}
        style={{ width: isOpen ? '250px' : '85px', transition: 'width 0.3s' }}
        aria-expanded={isOpen}
      >
        {isOpen && (
          <Link 
            to="/" 
            className="d-block position-relative "
            style={{
              paddingRight: '15px',
              borderBottom: '1px solid #f0f0f0',
            }}
          >
            <div className="d-flex justify-content-center p-2 LogoPianat">
              <img 
                src="/assets/images/logoComply.png" 
                alt="logo" 
                className=" w-100" 
              />
            </div>
          </Link>
        )}

        <div
          className="overflow-auto "
          style={{ maxHeight: 'calc(100vh - 80px)', paddingBottom: '.5rem' }}
        >
          {links.map((link) => {
            const active = location.pathname === link.href;
            return (
              <div key={link.href} className="mb-1">
                <Link
                  to={link.href}
                  className={`sidebar-link  ${active ? 'active' : ''} ${
                    !isOpen ? 'justify-content-center ' : ''
                  }`}
                  data-active={active}
                  title={!isOpen ? String(t(link.labelKey)) : ''}
                  aria-current={active ? 'page' : undefined}
                  style={{
                    display: 'flex',
                    alignItems: 'center'}}
                >
                  <div 
                    className="sidebar-icon mx-2" 
                    style={{ fontSize: !isOpen ? '1.5rem' : '1.1rem' }}
                  >
                    {link.icon}
                  </div>
                  {isOpen && <span className="text-truncate">{t(link.labelKey)}</span>}
                </Link>

              
           
          



              </div>
            );
          })}
        </div>
      </div>

      {/* Mobile Sidebar Drawer */}
      {isMobileOpen && (
        <div 
          className="position-fixed top-0 start-0 w-75 h-100 bg-white shadow-lg zindex-modal d-md-none"
          style={{ zIndex: 1050 }}
          role="dialog"
          aria-modal="true"
        >
          <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
            <img 
              src="/assets/images/Wholo Logo.png" 
              alt="logo" 
              style={{ height: '40px' }} 
            />
            <button 
              className="btn btn-sm btn-light" 
              onClick={() => setMobileOpen(false)}
              aria-label="Close sidebar"
            >
              ✕
            </button>
          </div>
          <div className="px-3 py-2">
            {links.map((link) => {
              const active = location.pathname === link.href;
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`d-block py-2 text-decoration-none ${
                    active ? 'fw-bold text-primary' : 'text-dark'
                  }`}
                  onClick={() => setMobileOpen(false)}
                  aria-current={active ? 'page' : undefined}
                >
                  <span className="me-2">{link.icon}</span>
                  {t(link.labelKey)}
                </Link>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
}

export default Sidebar;